import React from 'react';
import { ConfirmConfig } from '../../../../../component-controller-mod/component-serv/texteditor-fs-cp/upload-media-overlay/ts/uploadMediaOverlay';
import StatusBadge from '../../../../../component-controller-mod/component-serv/badge-fs-cp/dynamic-badge-op/ts/statusBadge';
import {
  ErrorIcon, InfoIcon, SuccessIcon, TrashIcon, WarningConfirmationIcon,
} from '../../../../../asset-controller-mod/asset-serv/icons/iconExporter';
import { MediaItem } from './mediaData';
import { toBadgeVariant } from './mediaHelpers';

// ─── Confirm Icons ────────────────────────────────────────────────────────────

export const CONFIRM_ICONS: Record<ConfirmConfig['status'], React.ReactNode> = {
  info:    <InfoIcon />,
  warning: <WarningConfirmationIcon />,
  success: <SuccessIcon />,
  error:   <ErrorIcon />,
};

// ─── Delete Button ────────────────────────────────────────────────────────────

export const DeleteButton = ({ onClick }: { onClick?: () => void }) => (
  <button
    type="button"
    className="scl--cms-pages-mediaPage-deleteBtn"
    onClick={onClick}
    aria-label="Delete"
  >
    <TrashIcon />
  </button>
);

// ─── Table Cell Components ────────────────────────────────────────────────────

export const FileNameCell = ({ item }: { item: MediaItem }) => (
  <div className="scl--cms-pages-mediaPage-fileNameCell">
    <div className="scl--cms-pages-mediaPage-thumbnail">
      <img src={item.imageSrc} alt={item.title} />
    </div>
    <span className="scl--cms-pages-mediaPage-fileName">{item.title}</span>
  </div>
);

export const StatusCell = ({ status }: { status: MediaItem['status'] }) => (
  <StatusBadge
    variant={toBadgeVariant(status)}
    label={
      status === 'active'   ? 'Active'   :
      status === 'deactive' ? 'Deactive' :
      'Draft'
    }
  />
);